import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import queryClient from '@/lib/queryClient'
import Root from '@/app/root'

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Root />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: 'var(--bg-secondary)',
            color: 'var(--text-primary)',
            border: '1px solid var(--border-subtle)',
            fontFamily: 'var(--font-sans)',
          },
        }}
      />
    </QueryClientProvider>
  )
}
